import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

interface City {
  name: string,
  code: string
}
@Component({
  selector: 'app-dropdown',
  template: `
  <p-dropdown *ngIf="!valuePrimitve" [showClear]="true" [options]="optionsList" [placeholder]="placeholder" [filter]="filter" [filterBy]="filterBy" [formControl]="formControl" [formlyAttributes]="field" placeholder="Select" [optionLabel]="optionLabel" (onChange)="onChange($event)"></p-dropdown>
  <p-dropdown *ngIf="valuePrimitve" [showClear]="true" [options]="optionsList" [placeholder]="placeholder" [filter]="filter" [filterBy]="filterBy" [formControl]="formControl" [formlyAttributes]="field" placeholder="Select" [optionLabel]="optionLabel" [optionValue]="optionValue" (onChange)="onChange($event)"></p-dropdown>`,
  styleUrls: ['./dropdown.component.less']
})


export class DropdownComponent extends FieldType {
  cities: City[] = [];
  defaultOptions = {
    templateOptions: { options: [] },
  };
  formControl!: FormControl;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public get optionsList() { return this.to.optionsList !== undefined ? this.to.optionsList : []; }
  public get placeholder() { return this.to.placeholder !== undefined ? this.to.placeholder : ''; }
  public get filter(): boolean { return this.to.filter !== undefined ? this.to.filter : false; }
  public get editable(): boolean { return this.to.editable !== undefined ? this.to.editable : false; }
  public get valuePrimitve(): boolean { return this.to.valuePrimitve !== undefined ? this.to.valuePrimitve : false; }
  public get filterBy(): string { return this.to.filterBy !== undefined ? this.to.filterBy : 'label'; }
  public get optionLabel(): string { return this.to.optionLabel !== undefined ? this.to.optionLabel : 'label'; }
  public get optionValue(): string { return this.to.optionValue !== undefined ? this.to.optionValue : 'value'; }
  public get dataKey(): string { return this.to.dataKey !== undefined ? this.to.dataKey : 'value'; }


  onChange($event: any) {
    if (this.to.onChange) {
      this.to.onChange($event, this.field);
    }
  }

}
